// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"unsubscribe_buttonGroup__2qdQu","button":"unsubscribe_button__20Mk3","colorReverse":"unsubscribe_colorReverse__37vGm"};